import { isSettingsPath } from '@/features/settings/settingsVisibility';
import { ROLE_GROUPS } from '@/shared/auth';
import type { NavEntry } from './adminNavigationTypes';

const { workspaceAdmin, workspaceMembers } = ROLE_GROUPS;
const under = (base: string) => (path: string) => path.startsWith(`${base}/`);

export const settingsEntry: NavEntry = {
  to: '/settings',
  label: 'Einstellungen',
  roles: workspaceAdmin,
  alsoPlatformAdmin: true,
  matches: isSettingsPath,
};

/** Konto-Menü: gehört zur eigenen Anmeldung und fehlt in einer Support-Sitzung. */
export const accountEntries: NavEntry[] = [
  {
    to: '/account/security',
    label: 'Kontosicherheit',
    roles: workspaceMembers,
    homeSessionOnly: true,
  },
  {
    to: '/plugins',
    label: 'Plugins',
    roles: workspaceMembers,
    homeSessionOnly: true,
    matches: under('/plugins'),
  },
];

/** Abschnitt „Plattform · nur du“; dieselben Grenzen wie in den Einstellungen. */
export const platformEntries: NavEntry[] = [
  { to: '/platform/workspaces', label: 'Workspaces', platformOnly: true },
  {
    to: '/settings/integrations',
    label: 'Buchungsportal-Konten',
    roles: workspaceAdmin,
    platformWorkspaceOnly: true,
  },
  {
    to: '/system/audit',
    label: 'Protokolle & Meldungen',
    platformOnly: true,
    matches: (path) => path === '/system/outbox' || path === '/system/webhook-events',
  },
];
